import React from 'react';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';

import { Flex, Text } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';
import EmptyCourses from 'Components/EmptyCourses';
import { withOffset } from 'Context/LayoutContext';
import { useGoToBrowse } from 'Domain/ExternalNavigation';
import { useConfig } from 'Context/ConfigContext';

const EmptyWrapper = styled((props) => <Flex flexDirection={'column'} flex={1} {...props} />)`
  padding-top: calc(${getTheme('space.NAVBAR_HEIGHT')}px + ${getTheme('space.APP_TOP_OFFSET')}px);
  height: 100vh;
`;

const EmptyCoursesContainer = (props) => {
  const { t } = useTranslation('myCourses');
  const { myCourses } = useConfig();
  const { enableBrowseUrl, browseCoursesUrl } = useGoToBrowse();

  const handleLinkClick = () => {
    window.location.replace(browseCoursesUrl);
  };

  return (
    <EmptyWrapper {...props}>
      <Text textStyle={'heading3'} color={'text'} px={4} flex={0}>
        {t('BANNER.TITLE1')}
      </Text>
      <Flex justifyContent={'center'} alignItems={'center'} flex={1}>
        <EmptyCourses
          imageUrl={myCourses?.emptyCoursesUrl ?? null}
          title={t('EMPTY.TITLE')}
          description={
            <Trans defaults={t('EMPTY.DESCRIPTION')} components={[<br key={'space'} />]} />
          }
          btnLabel={t('EMPTY.BUTTON_LABEL')}
          onClickBtn={enableBrowseUrl && handleLinkClick}
        />
      </Flex>
    </EmptyWrapper>
  );
};

export default withOffset(EmptyCoursesContainer);
